<template>
    <!-- scegli il locale -->
    <div class="container nopadding">
        <div class="wrapper login">
            <h1 class="white text-center"><b>{{ $t('scegli_locale') }}</b></h1><br>
            <div class="content text-center">
                <ul class="locali">
                    <li v-for="room in this.rooms"
                        :key="room.id">
                        <a href="#"
                           @click.prevent="setCurrentLocale(room)">
                            {{ room.nome_locale }}
                        </a>
                    </li>
                </ul>
                <button v-if="!!$route.query.canGoBack" class="btn btn-default btn-sm mt-3" @click="$router.go(-1)">
                    « {{ $t('btn_indietro') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';

import {trovaConsegnaCitta} from "../../libraries/utils";

export default {
    name: "RoomSelect",
    computed: {
        point_id: function () {
            if (this.$route.query.pointId) {
                return Number(this.$route.query.pointId);
            }

            return null;
        },
        rooms: function () {
            let rooms = this.getRooms(this.point_id);
            const roomsIds = this.$route.query.rooms_id;

            if (this.$route.query.service) {
                rooms = rooms.filter(room => {
                    const roomServices = this.getRoomServices(room, true).map(
                        service => service.type,
                    );

                    return roomServices.includes(this.$route.query.service);
                });
            }

            if (roomsIds) {
                rooms = rooms.filter((room) => {
                    return roomsIds.includes(room.id);
                })
            }

            return rooms;
        },
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('restaurant', {
            restaurant: state => state
        }),
        ...mapGetters('restaurant', {
            getRooms: 'rooms',
            getRoomServices: 'roomServices'
        }),
        ...mapGetters('order', {
            cartMustBeReset: 'cartMustBeReset'
        })
    },
    methods: {
        setCurrentLocale: function (room) {
            if (!room.licenza.f_attivo) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [room.licenza.testo]
                });

                return;
            }

            const resetHome = (reset) => {
                if (reset) {
                    this.resetOrder();
                }
                this.setLocale(room);

                let address = null;

                if (this.$route.params.address) {
                    address = {...this.$route.params.address};
                    const cities = this.$route.params.cities.filter((city) => {
                        return city.consegnaCitta.id_locale === room.id;
                    }).map((city) => {
                        return city.consegnaCitta;
                    });

                    const city = trovaConsegnaCitta(cities, address.lng, address.lat);

                    if (city) {
                        address.id_consegna_citta = city.id;
                    }
                }

                if (this.$route.query.service === 'PRENOTAZIONI') {
                    this.$router.push({name: 'reservations.reserve'});
                } else {
                    this.setDefaultParams({
                        id_punto_di_servizio_default: this.point_id,
                        type_default: this.$route.query.service,
                        address_default: address
                    });

                    this.$router.push({name: 'home'});
                }
            };

            if (this.cartMustBeReset(room.id)) {
                this.showModalCartReset({
                    show: true,
                    callback: (success) => {
                        if (success) {
                            resetHome(true);
                        }
                    }
                });
            } else {
                resetHome(false);
            }
        },
        ...mapActions('global', [
            'showModalCartReset',
            'showModalErrors'
        ]),
        ...mapActions('restaurant', [
            'setLocale',
        ]),
        ...mapActions('order', {
            setDefaultParams: 'setDefaultParams',
            resetOrder: 'reset'
        })
    }
}
</script>
